// Copyright (c) 2016 Deere & Company
import PropTypes from 'prop-types';
import React from 'react';
import UserSettingsNavigationItem from './user-settings-navigation-item';

const UserSettingsNavigationList = ({ routes }) => (
    <ul className="user-settings-navigation-list">
        {routes.map((route, index) => (
            <UserSettingsNavigationItem
            // eslint-disable-next-line react/no-array-index-key
                key={index}
                label={route.name}
                path={route.path}
            />
        ))}
    </ul>
);

UserSettingsNavigationList.displayName = 'UserSettingsNavigationList';
UserSettingsNavigationList.propTypes = {
    routes: PropTypes.array.isRequired,
};

export default UserSettingsNavigationList;
